import React, { Component, Fragment, createRef } from 'react';
import { Button, FormGroup, Col, Container, Input, Row } from 'reactstrap';
import swal from 'sweetalert2';
import jwt from 'jsonwebtoken';
import ApiCall from '../../services/ApiCall';
import Helper, { showError, paramsToObj } from '../../services/Helper';
// import {Redirect} from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'


const style = {
    backgroundImage:
        'linear-gradient(#9675ce,#9675ce),linear-gradient(rgba(120,130,140,.13),rgba(120,130,140,.13))',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    backgroundPosition: 'center bottom,center calc(99%)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '0 2px,100% 1px',
    padding: 0
};

class ForgotPassword extends Component {
    constructor() {
        super()
        this.reRef = createRef()
      }

    state = {
        email: '',
        token: null,
        tokenValid: null
    };

    componentWillMount() {
        let objectParams = paramsToObj(this.props.location.search)
        if (Object.keys(objectParams).length > 0) {
            this.setState({
                ...objectParams
            })
        }
        let getTokenUser = localStorage.getItem('token')
        if (getTokenUser) window.location = '/astra/#/home'
    }

    componentDidMount() {
        let { token } = this.state
        if (token) {
            ApiCall.validateTokenForgotPassword({
                formData: {
                    token
                }
            }).then(res => {
                this.setState({
                    tokenValid: true
                })
            }).catch(err => {
                showError(err);
            })
        }
    }

    onClickSend = async (e) => {
        try {
            e.preventDefault()
            const tokenCaptcha = await this.reRef.current.executeAsync();
            this.reRef.current.reset()

            await ApiCall.getTokenForgotPassword({
                formData: {
                    email: this.state.email,
                    tokenCaptcha
                }
            }).then(res => {
                console.log(res.data.data, 'token forgot password')
            })
            await swal({
                type: 'success',
                title: 'Success',
                text: 'Link untuk reset password telah dikirim ke email anda, silahkan periksa email anda.'
            })
            window.location = '/astra/#/login'
        } catch (err) {
            showError(err)
        }
    }

    onResetPassword = async (e) => {
        try {
            let { token, password, passwordConfirmation } = this.state
            e.preventDefault()
            await ApiCall.userChangePassword({
                formData: {
                    token,
                    password,
                    passwordConfirmation
                }
            })
            await swal({
                type: 'success',
                title: 'Success',
                text: 'Sukses reset password, silahkan login dengan email dan password baru anda.'
            })
            window.location = '/astra/#/login'
        } catch (err) {
            showError(err)
        }
    }

    render() {
        let { email, password, passwordConfirmation, token, tokenValid } = this.state;
        if (token && tokenValid === null) return ''

        return (
            <div className="app flex-row align-items-center background-home">
                <div className="background-top">
                    <div className="background-astra">
                        <img
                            src={'/assets/img/astra-international.png'}
                            className=""
                            alt="logo astra"
                        />
                    </div>
                    <div className="background-indo">
                        <img
                            src={'/assets/img/login/indonesia.png'}
                            className=""
                            alt="indonesia"
                        />
                    </div>
                </div>
                <Container>
                    <div className="card-form-login">
                        <a
                            style={{
                                fontSize: '1.5rem'
                            }}
                            href="/astra/#/login"
                        >
                            <i className="fa fa-arrow-left" />
                        </a>
                        <div className="text-center logo">
                            G R E E N
                            <img
                                src={'/assets/img/brand/logo-agc.png'}
                                className=""
                                alt="logo astra green company"
                            />
                            C O M P A N Y
                        </div>

                        {!token && (
                            <Fragment>
                                <p className="text-uppercase text-semibold m-b-15">
                                    Type email to sending the reset password link
                                </p>

                                <form onSubmit={this.onClickSend}>
                                    <ReCAPTCHA 
                                    ref={this.reRef}
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                    size="invisible"
                                    />
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Input
                                                    style={this.style}
                                                    value={email}
                                                    bsSize="lg"
                                                    type="text"
                                                    id="name"
                                                    placeholder="Email"
                                                    onChange={e => {
                                                        this.setState({
                                                            email: e.target.value
                                                        });
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup></FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <Button
                                                className="btn btn-info btn-lg btn-loading btn-block text-uppercase waves-effect waves-light"
                                                type="submit"
                                            >
                                                Send
                                            </Button>
                                        </Col>
                                    </Row>
                                </form>
                            </Fragment>
                        )}
                        {(token && tokenValid === true) && (
                            <Fragment>
                                <p className="text-uppercase text-semibold m-b-15">
                                    Type password to reset your password
                                </p>

                                <form onSubmit={this.onResetPassword}>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Input
                                                    style={this.style}
                                                    value={password}
                                                    bsSize="lg"
                                                    type="password"
                                                    id="password"
                                                    placeholder="Password"
                                                    onChange={e => {
                                                        this.setState({
                                                            password: e.target.value
                                                        });
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Input
                                                    style={this.style}
                                                    value={passwordConfirmation}
                                                    bsSize="lg"
                                                    type="password"
                                                    id="passwordConfirmation"
                                                    placeholder="Password Confirmation"
                                                    onChange={e => {
                                                        this.setState({
                                                            passwordConfirmation: e.target.value
                                                        });
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <Button
                                                className="btn btn-primary btn-lg btn-loading btn-block text-uppercase waves-effect waves-light"
                                                type="submit"
                                            >
                                                Reset
                                            </Button>
                                        </Col>
                                    </Row>
                                </form>
                            </Fragment>
                        )}
                    </div>
                </Container>
                <style jsx>{`
                    a, a:hover {
                        color: unset;
                    }
                    .background-home {
                        background: url('/assets/img/login/bg22.png');
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                        min-height: 100%;
                        min-width: 100%;
                        width: 100%;
                        height: auto;
                        position: fixed;
                        top: 0;
                        left: 0;
                        z-index: -1000;
                    }

                    .background-astra {
                        position: fixed !important;
                        left: 10px !important;
                        height: 40px !important;
                        top: 10px !important;
                    }
                    .background-indo {
                        position: fixed !important;
                        right: 10px !important;
                        height: 50px !important;
                        top: 10px !important;
                    }

                    .background-astra img {
                        height: 40px !important;
                    }
                    .background-indo img {
                        height: 50px !important;
                    }

                    @media only screen and (max-width: 580px) {
                        .background-top {
                            display: none !important;
                        }
                    }

                    .card-form-login {
                        background-color: #fff;
                        width: 400px;
                        margin: 0% 60%;
                        padding: 25px;
                        height: auto;
                    }

                    @media only screen and (max-width: 1024px) {
                        .card-form-login {
                            width: 400px !important;
                            margin: 0 45% !important;
                        }
                    }
                    @media only screen and (max-width: 756px) {
                        .card-form-login {
                            width: 400px !important;
                            margin: 0 auto !important;
                        }
                    }

                    @media only screen and (max-width: 600px) {
                        .card-form-login {
                            width: 350px !important;
                            margin: 0 auto !important;
                        }
                    }
                    @media only screen and (max-width: 400px) {
                        .card-form-login {
                            width: 300px !important;
                            margin: 0 auto !important;
                        }
                    }

                    .logo {
                        font-size: 1rem;
                        height: 4rem;
                    }

                    .logo img {
                        /*background-color:#fff; */
                        /*width: 400px; */
                        /*margin: 0% 60%; */
                        /*padding: 25px; */
                        height: 3em;
                        display: inline-block;
                    }

                    .logo .green {
                        display: inline-block;
                    }
                    .logo .company {
                        display: inline-block;
                    }
                `}</style>
            </div>
        );
    }
}

export default ForgotPassword;
